import { useTranslation } from 'react-i18next'
import { useSparks } from '../../api/hooks'
import { useTeamCredits } from '../../hooks/useTeams'
import { useActiveWallet } from './useActiveWallet'

/** Match the account switcher's spendable balance, including member allowances. */
export function useActiveWalletBalance(enabled = true) {
  const { t } = useTranslation('settings')
  const wallet = useActiveWallet()
  const personal = useSparks(undefined, enabled && wallet.kind === 'personal')
  const team = useTeamCredits(
    wallet.team?.id ?? null,
    enabled && wallet.kind === 'team' && wallet.canViewFinancials,
  )
  const query = wallet.kind === 'personal' ? personal : team
  const label = wallet.kind === 'personal'
    ? t('settingsModal.billing.personalCredits')
    : t('settingsModal.billing.teamCredits', { name: wallet.team.name })
  return { wallet, query, balance: query.data?.balance, label }
}
